export default __webpack_public_path__ + "static/media/Anyswap.58b74fdc.svg";